export const SIDEBAR = 'sidebar';
export const TOP = 'top';
export const TAB = 'tab';

export type NavigationContainer = typeof SIDEBAR | typeof TOP | typeof TAB;
